import React from 'react';
import './Footer.css';
import AdSense from './AdSense';

const Footer = () => {
  return (
    <footer className="main-footer">
      {/* Footer Banner Ad - Only shows if valid ad slot is configured */}
      {process.env.REACT_APP_ADSENSE_SLOT_FOOTER && (
        <AdSense 
          adSlot={process.env.REACT_APP_ADSENSE_SLOT_FOOTER}
          adFormat="auto"
          fullWidthResponsive={true}
          className="adsense-banner"
        />
      )}
      
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-brand">
              <img src="/favicon-32x32.png" alt="Logo" className="footer-logo-img" />
              <h3>Financial Calculator</h3>
            </div>
            <p>Your trusted financial calculator for smart financial planning</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#home" onClick={(e) => { e.preventDefault(); window.location.hash = 'home'; }}>Home</a></li>
              <li><a href="#about" onClick={(e) => { e.preventDefault(); window.location.hash = 'about'; }}>About</a></li>
              <li><a href="#contact" onClick={(e) => { e.preventDefault(); window.location.hash = 'contact'; }}>Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Download App</h4>
            <a 
              href="https://play.google.com/store/apps/details?id=com.kenyanfinancialhub.app"
              target="_blank"
              rel="noopener noreferrer"
              className="play-store-button"
              aria-label="Download from Google Play Store"
            >
              <svg className="play-store-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.11L13.69,12L3.84,21.89C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
              </svg>
              <div className="play-store-text">
                <span className="play-store-label">Get it on</span>
                <span className="play-store-name">Google Play</span>
              </div>
            </a>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2026 Financial Calculator. All rights reserved.</p>
          <p className="footer-credit">
            Made by <a href="https://itsolutions.co.ke" target="_blank" rel="noopener noreferrer">IT Solutions (Kenya)</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
